import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        // 获取单条
        GetAgentRebateApplyById(id) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: id
            };
            $http.get('api/Agent/GetAgentRebateApplyById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.AreaList = Data.AreaList
                    this.RebateImgs = Data.RebateImgs
                    console.log(Data.AreaList)
                });
            });
        },
        // 获取公司基本信息
        GetNewAgentByCustomerId(CustomerId) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: CustomerId
            };

            $http.get('api/Agent/GetNewAgentByCustomerId', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.baseInfo = util.filterAndSetData(this.$refs.baseInfo.refsGetInitData(), Data);
                });
            });
        },
        RebateApplyAudi(data) {
            $http.post('api/Agent/RebateApplyAudit', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '升级审核成功！',
                        type: 'success'
                    });
                    this.$emit('reload-list');
                    this.close();
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/AgentAudit/components/examinDialog/services.js